import type { PerformanceCoreDatapoint, PerformanceDatapoint } from 'owa-analytics';
import type MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import type TableView from 'owa-mail-list-store/lib/store/schema/TableView';

/**
 * Peformance datapoint that tracks end to end time from selection of an email in message list to rendering the content on reading pane.
 */
let selectMailItemDp: PerformanceCoreDatapoint | PerformanceDatapoint | undefined = undefined;
export interface SMICustomDataRawArguments {
    mailListItemSelectionSource: MailListItemSelectionSource;
    tableView: TableView;
    rowKey: string;
    shouldExpandAllItemParts?: boolean;
}

let smiCustomDataRawArguments: SMICustomDataRawArguments | undefined = undefined;

export function getSelectMailItemDatapoint():
    | PerformanceCoreDatapoint
    | PerformanceDatapoint
    | undefined {
    return selectMailItemDp;
}

export function setSelectMailItemDatapoint(
    datapoint: PerformanceCoreDatapoint | PerformanceDatapoint | undefined
): void {
    selectMailItemDp = datapoint;
}

export function setSmiCustomDataRawArguments(
    mailListItemSelectionSource: MailListItemSelectionSource,
    tableView: TableView,
    rowKey: string,
    shouldExpandAllItemParts?: boolean
): void {
    smiCustomDataRawArguments = {
        mailListItemSelectionSource,
        tableView,
        rowKey,
        shouldExpandAllItemParts,
    };
}

export function getSmiCustomDataRawArguments(): SMICustomDataRawArguments | undefined {
    return smiCustomDataRawArguments;
}

export function resetSmiCustomDataRawArguments(): void {
    smiCustomDataRawArguments = undefined;
}
